module.exports = __webpack_public_path__ + "img/744.42500d75.jpg";